module.exports = __webpack_public_path__ + "static/media/laurastromboni.9cd5535e.svg";